export default "__VITE_ASSET__h25k4ouK__"